import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';
import { handleResponseError } from '../../utils/helpers/error';

export const getCategories = createAsyncThunk('categories.getCategories', async ({ }, { rejectWithValue }) => {
  try {
    const { data: { categories } } = await api.categories.getCategories();
    return categories;
  } catch (error) {
    handleResponseError(error);
    return rejectWithValue();
  }
});

export const addCategory = createAsyncThunk('categories.addCategory', async ({
  name, onSuccess, onError,
}, { rejectWithValue }) => {
  try {
    const { data: { newCategory, message } } = await api.categories.addCategory(name);
    onSuccess(message);
    return newCategory;
  } catch (error) {
    handleResponseError(error, onError);
    return rejectWithValue();
  }
});

export const updateCategory = createAsyncThunk('categories.updateCategory', async ({
  id, name, onSuccess, onError,
}, { rejectWithValue }) => {
  try {
    const { data: { message } } = await api.categories.updateCategory(id, name);
    onSuccess(message);
    return {
      _id: id,
      name,
    };
  } catch (error) {
    handleResponseError(error, onError);
    return rejectWithValue();
  }
});

export const deleteCategory = createAsyncThunk('categories.deleteCategory', async ({
  id, onSuccess, onError,
}, { rejectWithValue }) => {
  try {
    const { data: { message } } = await api.categories.deleteCategory(id);
    onSuccess(message);
    return id;
  } catch (error) {
    handleResponseError(error, onError);
    return rejectWithValue();
  }
});
